import { MdOutlineLogin } from 'react-icons/md';

import { useApp } from '@/context/app';
import { Scanner } from '@hubmaster/components';
import { isURL } from '@hubmaster/tools/src/functions';
import { Button } from '@hubmaster/ui';
import { toast } from 'sonner';

export function NoLogged() {
	const { updateToken } = useApp();

	function setCredentials() {
		let token: any = '';

		while (token === '') {
			token = prompt('Insira o token:');
		}

		updateTokenByQRCode(token);
	}

	function updateTokenByQRCode(qr: string) {
		let token: string | null = qr;
		if (isURL(qr)) {
			const params = new URL(qr);
			token = params.searchParams.get('token');
		}

		if (token) {
			updateToken(token);
		} else {
			toast.error('QRCode Inválido');
		}
	}

	return (
		<div className="px-4 text-center">
			<h1 className="text-lg font-bold">Faça login agora</h1>
			<p>Para acessar o sistema você precisa fazer login!</p>
			<div className="mt-4 flex flex-col items-center justify-center gap-2">
				<Scanner
					onRead={updateTokenByQRCode}
					type="qrcode"
					className="h-12"
					popup={{
						title: 'Código Token',
						description: 'Insira o código token',
						input: {
							placeholder: 'oeffad-adsfadf-adfad-adfdf',
							type: 'text',
						},
					}}
				/>
				<span>ou</span>
				<Button
					onClick={setCredentials}
					variant={'outline'}
					className="h-12 gap-2 rounded-xl"
				>
					<MdOutlineLogin size={20} />
					Com credenciais
				</Button>
			</div>
		</div>
	);
}
